<div class="admin-chats sin-border-rendondeado">
  <mat-toolbar class="bg-primario-75">
    <mat-icon class="mr-2">support_agent</mat-icon>
    <span>SOPORTE</span>
    <div class="spacer"></div>
    <button mat-icon-button class="bordered-icon-button" (click)="closeAdmin()">
      <mat-icon>close_round</mat-icon>
    </button>
  </mat-toolbar>
  <mat-toolbar class="content-buscador bg-blanco border-bottom">
    <form [formGroup]="form" class="width-content mt-1">

      <mat-form-field class="width-content" appearance="outline">
        <mat-label>Buscar por ID de usuario</mat-label>
        <input
          type="text"
          matInput
          formControlName="paramFilter"
          [matAutocomplete]="auto"
        >
        <button
          matSuffix mat-icon-button aria-label="Clear"
          (click)="clearParamFilter()"
        >
          <mat-icon>close</mat-icon>
        </button>
        <mat-autocomplete
          #auto="matAutocomplete"
          (optionSelected)="onOptionSelected($event.option.value, form, 'paramFilter', 'param')"
        >
          <mat-option *ngFor="let option of options" [value]="option"
                      class="font-size-14 pr-2 pl-2 pt-2 pb-2 divisor-bottom">
            <div class="acortar-texto">
              <strong>Usuario:</strong> {{ option?.id }}
              - {{ option?.nombre }} {{ option?.apeidoPaterno }} {{ option?.apeidoMaterno }}
            </div>
            <div class="acortar-texto font-size-12">
              <strong>Negocio:</strong> {{ option?.negocio?.id }} - {{ option?.negocio?.nombre }}
            </div>
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>

    </form>

    <button
      mat-icon-button
      class="bordered-icon-button mb-4 ml-1"
      #tooltip="matTooltip"
      [matTooltip]="tooltipContent"
      matTooltipClass="tooltip-linnegocios"
    >
      <mat-icon>help</mat-icon>
    </button>

  </mat-toolbar>
  <div class="content-chats">
    <mat-tab-group>
      <mat-tab>
        <ng-template mat-tab-label>
          MIOS
          <span
            class="badge ml-2 mb-1 mat-badge-primario"
            [matBadge]="notificacionesMisChats"
            matBadgePosition="below before"
            [matBadgeHidden]="notificacionesMisChats == 0"
          ></span>
        </ng-template>
        @if (myChats.length === 0) {
          <p class="p-3 tc-gray">
            No hay chats pendientes por atender.
          </p>
        } @else {
          <app-admin-item-chat
            *ngFor="let chat of myChats"
            [chat]="chat"
            [agente]="'own'"
            (selectedChat)="viewChat($event)"
          ></app-admin-item-chat>
        }
      </mat-tab>

      <mat-tab>
        <ng-template mat-tab-label>
          OTROS
          <span
            class="badge ml-2 mb-1 mat-badge-primario"
            [matBadge]="notificacionesOtrosChats"
            matBadgePosition="below before"
            [matBadgeHidden]="notificacionesOtrosChats == 0"
          ></span>
        </ng-template>
        @if (allChats.length === 0) {
          <p class="p-3 tc-gray">
            No hay chats pendientes por atender.
          </p>
        } @else {
          <app-admin-item-chat
            *ngFor="let chat of allChats"
            [chat]="chat"
            [agente]="'other'"
            (selectedChat)="viewChat($event)"
          ></app-admin-item-chat>
        }
      </mat-tab>
    </mat-tab-group>
  </div>
</div>
